import React from 'react'
import { ORDERS_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { ListChecked } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import OrderContainer from '../containers/Orders/Order/Order.container';
import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const Orders = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case ORDERS_TYPE.ORDER:
                return 'Ordenes de trabajo'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case ORDERS_TYPE.ORDER:
                return 'Módulo para la gestión y el seguimiento de las ordenes de trabajo asociadas al turno actual.'    
        }
    };

    const OrdersBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {ORDERS_TYPE[type] !== ORDERS_TYPE['ORDERS-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [ORDERS_TYPE.ORDER]: OrderContainer
    }
    const ComponentToRender = typeToComponentMap[type];
    console.log('cositas',typeToComponentMap[type]);
    

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.orders} />} />}
                header={<Heading title={TypeTitle(type)} icon={<ListChecked size={50} />} breadcrumbs={<OrdersBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default Orders